import React from 'react';
import { MenuViewer } from '../components/sections/MenuViewer';

export const MenuPage = () => {
  return (
    <div className="pt-24 md:pt-32 bg-ivory min-h-screen">
      <MenuViewer />
    </div>
  );
};